import { memo } from "react";

export interface OutletStatusComponentProps {
  label: string;
  /** Text size for the status word - the design uses 12px in the switcher and 14px in the list. */
  className?: string;
}

/** The green `Active` / `Inactive` marker used in outlet meta lines. */
const OutletStatusComponent = memo(function OutletStatusComponent({
  label,
  className,
}: OutletStatusComponentProps) {
  return (
    <span className="inline-flex items-center gap-[4px]">
      <span className="h-[6px] w-[6px] shrink-0 rounded-full bg-gradient-to-b from-[#259A51] to-[#4DA86F]" />
      <span
        className={`bg-gradient-to-b from-[#259A51] to-[#4DA86F] bg-clip-text italic text-transparent ${
          className ?? ""
        }`}
      >
        {label}
      </span>
    </span>
  );
});

export default OutletStatusComponent;
